const emptyBlueprint = {
  name: "",
  creationDate: "",
  author: "",
  organization: "",
  description: "",
  verified: false,
};

export const handleCloseDescriptionPopover = (e, setActivePopover) => {
  e.preventDefault();
  e.stopPropagation();
  setActivePopover(emptyBlueprint);
};
